<template>
  <div class="wrap">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>账户管理</el-breadcrumb-item>
      <el-breadcrumb-item>子账户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="addBtn">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-plus"
        @click="addUser()"
        >新增用户</el-button
      >
    </div>
    <el-table :data="tableData" style="width: 632px" border>
      <el-table-column prop="user_id" label="用户id" width="180" align="center">
      </el-table-column>
      <el-table-column
        prop="user_name"
        label="用户名称"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column align="center" width="270" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="updatePassword(scope.$index, scope.row)"
            >修改密码</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >注销</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div
      v-show="addShow"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="addBox"
    >
      <div class="addBoxC">
        <el-form ref="form" :model="addForm" label-width="80px" size="mini">
          <el-form-item label="用户ID">
            <el-input v-model="addForm.user_id"></el-input>
          </el-form-item>
          <el-form-item label="用户名称">
            <el-input v-model="addForm.user_name"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="addForm.password" show-password></el-input>
          </el-form-item>
          <el-form-item label="分配角色">
            <el-checkbox-group v-model="checkList">
              <el-checkbox v-for="(item) in roleData" :label="item.role_id" :key="item.role_id">{{item.role_name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item size="large">
            <el-button size="mini" @click="createUser()" type="primary"
              >立即创建</el-button
            >
            <el-button size="mini" @click="colseAddBox()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      v-show="editShow"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="addBox"
    >
      <div class="addBoxC">
        <el-form ref="form" :model="editForm" label-width="80px" size="mini">
          <el-form-item label="用户ID">
            <el-input readonly="readonly" v-model="editForm.user_id"></el-input>
          </el-form-item>
          <el-form-item label="用户名称">
            <el-input v-model="editForm.user_name"></el-input>
          </el-form-item>
          <el-form-item label="分配角色">
            <el-checkbox-group v-model="checkList">
               <el-checkbox v-for="(item) in roleData" :label="item.role_id" :key="item.role_id">{{item.role_name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item size="large">
            <el-button size="mini" @click="editSubmit()" type="primary"
              >确定</el-button
            >
            <el-button size="mini" @click="colseAddBox()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      addForm: {
        user_id: "",
        user_name: "",
        password: ""
      },
      editForm: {
        user_id: "",
        user_name: "",
      },
      roleData: [],
      checkList: [],
      loading: false,
      addShow: false,
      editShow: false,
    };
  },
  created() {
    this.getSupplierUser();
    this.getRole();
  },
  methods: {
    /**
     * 获取用户列表
     */
    async getSupplierUser() {
      let res = await this.$Http.getSupplierUser();
      if (res.code == 0) {
        this.tableData = res.data;
      } else {
        this.$message.error("获取数据时异常！请稍后重试");
      }
    },
    /**
     * 获取角色列表
     */
    async getRole() {
      let res = await this.$Http.getRole();
      if (res.code == 0) {
        this.roleData = res.data;
      } else {
        this.$message.error("获取数据时异常！请稍后重试");
      }
    },
    /**
     * 新增用户
     */
    addUser() {
      this.addShow = true;
    },
    /**
     * 关闭窗口
     */
    colseAddBox() {
      this.addShow = false;
      this.editShow = false;
      this.checkList = [];
      this.addForm.user_name = "";
      this.addForm.user_id = "";
      this.addForm.password = "";
    },
    /**
     * 创建用户
     */
    async createUser(){
      if(!this.addForm.user_name||!this.addForm.user_id){
        this.$message({
          message: "请输入用户ID和用户名称",
          type: "warning",
        });
        return;
      }
      let params = {
        user_id: this.addForm.user_id,
        user_name: this.addForm.user_name,
        password: this.addForm.password,
        roleList: this.checkList
      };
      this.loading = true;
      let res = await this.$Http.createSupplierUser(params);
      if (res.code == 0) {
        this.loading = false;
        this.addShow = false;
        this.getSupplierUser();
        this.checkList = [];
        this.addForm.user_id = "";
        this.addForm.user_name = "";
        this.addForm.password = "";
        this.$message({
          message: "创建成功",
          type: "success",
        });
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
    },
    /**
     * 编辑
     */
    async handleEdit(index, row) {
      index;
      let user_id = row.user_id;
      let params = {
        user_id: user_id,
      };
      let res = await this.$Http.getEditUser(params);
      if (res.code == 0) {
        this.editForm = res.data.ScmSupplierUser;
        let keys = [];
        for (let i in res.data.ScmRoleUser) {
          keys.push(res.data.ScmRoleUser[i]);
        }
        this.checkList = keys;
        this.editShow = true;
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久注销该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let user_id = row.user_id;
          let params = {
            user_id,
          };
          let res = await this.$Http.deleteUser(params);
          if (res.code == 0) {
            this.getSupplierUser();
            this.$message({
              message: "注销成功",
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
        .catch(() => {});
    },
    /**
     * 编辑提交
     */
    async editSubmit() {
      if (!this.editForm.user_name) {
        this.$message({
          message: "用户名称不能为空",
          type: "warning",
        });
        return;
      }
      if (this.checkList.length < 1) {
        this.$message({
          message: "至少为用户设置一个角色！",
          type: "warning",
        });
        return;
      }
      let editForm = this.editForm;
      let params = {
        editForm: editForm,
        roleList: this.checkList,
      };
      this.loading = true;
      let res = await this.$Http.editUser(params);
      if (res.code == 0) {
        this.loading = false;
        this.editShow = false;
        this.getSupplierUser();
        this.checkList = [];
        this.$message({
          message: "修改成功",
          type: "success",
        });
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
    },
    /**
     * 修改密码
     */
    updatePassword(index, row){
      index
      this.$prompt('请输入密码', '修改密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: this.GLOBAL.passwordRegular,
        inputErrorMessage: '密码格式不正确'
      }).then( async ({ value }) => {
            let params = {
              user_id: row.user_id,
              password: value
            }
            let res = await this.$Http.resetPassword(params);
            if(res.code == 0){
              this.$message({
                type: 'success',
                message: '修改成功'
              });
            }else{
              this.$message({
                type: 'success',
                message: res.msg
              });
            }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    }

  },
};
</script>
<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  position: relative;
}
.addBtn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.addBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.addBoxC {
  width: 400px;
  background-color: #fff;
  padding: 15px;
  border-radius: 3px;
}
</style>